import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const units = [{
    value: pad(hours),
    label: 'Horas'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Seg'
  }];
  return <div className="w-full max-w-xs mx-auto" data-id="element-18" data-mp="10cl90c2f1s6r">
      <p className="flex items-center justify-center gap-1.5 text-[11px] sm:text-xs font-bold uppercase tracking-widest text-brandred" data-id="element-19" data-mp="10dmu79d5bv27">
        <ClockIcon className="w-4 h-4" aria-hidden="true" data-id="element-20" data-mp="1592821b5lqym" />
        La oferta termina en
      </p>
      <div className="mt-2 grid grid-cols-3 gap-2" role="timer" aria-live="off" aria-label={`Tiempo restante ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`} data-id="element-21" data-mp="xytvycxw8v45">
        {units.map(unit => <div key={unit.label} className="rounded-xl bg-navy text-white py-2.5 px-1 text-center shadow-md" data-id="element-22" data-mp="12rd9xb0hts9h">
            <div className="text-2xl sm:text-3xl font-extrabold tabular-nums leading-none" data-id="element-23" data-mp="f2kkzyiagkod">
              {unit.value}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-widest text-white/60" data-id="element-24" data-mp="o2qtt731kwh7">
              {unit.label}
            </div>
          </div>)}
      </div>
    </div>;
}